import { computed, makeAutoObservable } from 'mobx';
import { RouterBackoffice } from 'src/AppState/RouterBackoffice';
import { CollectionType } from 'src/domains/casino/models/models';

export class RedirectState {
    public constructor(private readonly routerBackoffice: RouterBackoffice) {
        makeAutoObservable(this);
    }

    // casino redirects

    public redirectToCollection = (collection: CollectionType): void => {
        switch (collection) {
            case 'casino':
                this.routerBackoffice.redirectToCasinoCollection(collection);
                break;
            case 'live-casino':
                this.routerBackoffice.redirectToCasinoCollection(collection);
                break;
            case 'virtuals':
                this.routerBackoffice.redirectToCasinoCollection(collection);
        }
    };

    public redirectToEditGame = (id: number, collection: CollectionType): void => {
        this.routerBackoffice.redirectToEditGame(id, collection);
    };

    @computed public get casinoIdParam(): number | null {
        return this.routerBackoffice.getParametersNumber('global', 'id');
    }

    @computed public get casinoTabParam(): string | null {
        return this.routerBackoffice.getParametersString('global', 'casino-tab');
    }

    @computed public get casinoViewParam(): string | null {
        return this.routerBackoffice.getParametersString('global', 'casino-view');
    }
}
